import { Link } from "react-router-dom";
import styled from "styled-components";

const IconWrapper = styled.div`
	margin-right: 4.5px;
	svg {
		vertical-align: middle;
	}
`;

const StyledLink = styled(Link)`
	color: unset;
	text-decoration: none;
`;

const DropDownContainer = styled.div`
	padding: 14px 16px;
`;

export { IconWrapper, StyledLink, DropDownContainer };
